/**
 * @generated SignedSource<<bf288cf061331c44eef6e6763c4066ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type realtimeUpdater_nativeIssueTable_issues$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraIssueEdge";
  } | null | undefined> | null | undefined;
  readonly jql: string | null | undefined;
  readonly " $fragmentType": "realtimeUpdater_nativeIssueTable_issues";
};
export type realtimeUpdater_nativeIssueTable_issues$key = {
  readonly " $data"?: realtimeUpdater_nativeIssueTable_issues$data;
  readonly " $fragmentSpreads": FragmentRefs<"realtimeUpdater_nativeIssueTable_issues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "realtimeUpdater_nativeIssueTable_issues",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "b4c334b7a561fdded3791060aeee02a7";

export default node;
